import React from 'react';
// import React, { Suspense, lazy } from 'react';
// import loadable from '@loadable/component';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import './App.css';

// const Home = lazy(() => import('./pages'));
// const Thesis = lazy(() => import('./pages/thesis'));
// const Andyou = lazy(() => import('./pages/andyou'));
// const Designco = lazy(() => import('./pages/designco'));
// const Amazon = lazy(() => import('./pages/amazon'));
// const Interviews = lazy(() => import('./pages/interviews'));
// const PageNotFound = lazy(() => import('./pages/PageNotFound'));

    // <Suspense fallback={<div>Loading...</div>}>
    // </Suspense>


import Home from './pages';
import Thesis from './pages/thesis';
import Andyou from './pages/andyou';
import Designco from './pages/designco';
import Amazon from './pages/amazon';
import Interviews from './pages/interviews';
import PageNotFound from './pages/PageNotFound';


function App(props) {
  return (
  <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/thesis' element={<Thesis />} />
        <Route path='/andyou' element={<Andyou />} />
        <Route path='/designco' element={<Designco />} />
        <Route path='/amazon' element={<Amazon />} />
        <Route path='/interviews' element={<Interviews />} />
        <Route path='/404' element={<PageNotFound/>} />
        <Route path='*' element={<Navigate replace to='/404'/>} />
      </Routes>
  </Router>
);
}

export default App;

